export const STATUS = {
  UNKNOWN: 'unknown',
  ON_TIME: 'on-time',
  CANCELED: 'canceled',
  DELAYED: 'delayed',
  TIME_CHANGED: 'time-changed',
  ARRIVED: 'arrived',
}

export const STATUS_MAPPINGS = {
  [STATUS.UNKNOWN]: '未知',
  [STATUS.ON_TIME]: '準時',
  [STATUS.CANCELED]: '取消',
  [STATUS.DELAYED]: '延誤',
  [STATUS.TIME_CHANGED]: '時間變更',
  [STATUS.ARRIVED]: '抵達',
}

export const STATUS_OPTIONS = [
  {
    value: STATUS.UNKNOWN,
    text: '未知'
  },
  {
    value: STATUS.ON_TIME,
    text: '準時'
  },
  {
    value: STATUS.CANCELED,
    text: '取消'
  },
  {
    value: STATUS.DELAYED,
    text: '延誤'
  },
  {
    value: STATUS.TIME_CHANGED,
    text: '時間變更'
  },
  {
    value: STATUS.ARRIVED,
    text: '抵達'
  },
]

export default {
  STATUS,
  STATUS_MAPPINGS,
  STATUS_OPTIONS,
}
